import React from 'react';
import { useGetEtzProfileBalance } from 'hooks/api/portfolio';
import MetricItem from 'components/MetricCard';
import messages from './EtzProfileBalance.messages';

const EtzProfileBalance: React.FC = () => {
  const { isLoading, data } = useGetEtzProfileBalance();

  return (
    <MetricItem label={messages.label} amount={data?.amount} isLoading={isLoading} />
  );
};

export default EtzProfileBalance;
